var helperGetDateFullYear = require('./helperGetDateFullYear')
var helperGetDateMonth = require('./helperGetDateMonth')

function helperGetYMD (date) {
  return new Date(helperGetDateFullYear(date), helperGetDateMonth(date), date.getDate())
}

module.exports = helperGetYMD



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetYMD.js
// module id = 511
// module chunks = 98